import { showDialog } from "../../../actions/notifications";
import Icon from "../../../controls/Icon";
import Modal from "../../../controls/Modal";
import Spinner from "../../../controls/Spinner";
import CopyClipboardInput from "../../../controls/CopyClipboardInput";
import PlaceholderTextArea from "../../../controls/PlaceholderTextArea";
import { Button, IconButton } from "../../../controls/TooltipControls";
import { ComponentEx, connect, translate } from "../../../controls/ComponentEx";
import { UserCanceled } from "../../../util/CustomErrors";
import opn from "../../../util/opn";
import { setUserAPIKey } from "../actions/account";
import { setLoginId, setOauthPending } from "../actions/session";
import { NEXUS_BASE_URL } from "../constants";
import { getPageURL } from "../util/sso";
import { clipboard } from "electron";
import * as React from "react";
import { ControlLabel, FormControl, FormGroup, InputGroup, } from "react-bootstrap";
import { findDOMNode } from "react-dom";
const API_ACCESS_URL = `${NEXUS_BASE_URL}/users/myaccount?tab=api+access`;
function LoginInProgress(props) {
    const { t, loginId, onCopyToClipboard } = props;
    return (React.createElement("form", null,
        React.createElement(FormGroup, null,
            React.createElement(ControlLabel, null, t("Vortex should have opened the following url in your default browser. " +
                "If that failed, please copy the url into your browser manually.")),
            React.createElement(InputGroup, null,
                React.createElement(FormControl, { type: "text", value: getPageURL(loginId), disabled: true }),
                React.createElement(InputGroup.Addon, null,
                    React.createElement(IconButton, { className: "btn-embed", icon: "clipboard", tooltip: t("Copy to clipboard"), onClick: onCopyToClipboard }))))));
}
function nop() {
    // nop
}
class LoginDialog extends ComponentEx {
    // private mKeyValidation = /^[a-zA-Z0-9\-]*$/;
    mKeyValidation = /^[a-zA-Z0-9\-=]*$/;
    mModalRef = React.createRef();
    constructor(props) {
        super(props);
        this.initState({
            troubleshoot: false,
            apiKeyInput: "",
            requested: false,
            context: undefined,
            showElement: false,
            invalidToken: false,
        });
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.visible && !this.props.visible) {
            this.nextState.troubleshoot = false;
            this.nextState.apiKeyInput = "";
        }
        if (newProps.loginId !== this.props.loginId &&
            this.props.loginId === undefined) {
            this.nextState.troubleshoot = false;
            this.nextState.apiKeyInput = "";
        }
        if (newProps.loginError !== this.props.loginError) {
            this.nextState.troubleshoot = true;
        }
    }
    render() {
        const { troubleshoot } = this.state;
        const { t, loginId, visible, oauthPending } = this.props;
        return (React.createElement(Modal, { backdrop: "static", id: "login-dialog", show: visible || oauthPending !== undefined, onHide: this.hide },
            React.createElement(Modal.Body, { ref: this.mModalRef },
                React.createElement(IconButton, { className: "close-button", id: "btn-close-login", onClick: this.close, tooltip: t("Close"), icon: "close" }),
                troubleshoot ? this.renderTroubleshoot() : this.renderRegular())));
    }
    renderRegular() {
        const { t, loginId, oauthPending, visible } = this.props;
        const { requested, showElement } = this.state;
        return (React.createElement("div", { className: "login-content" },
            React.createElement(Icon, { className: "nexus-header", name: "nexus-header", svgStyle: "#login-dialog path { fill: black }" }),
            visible && oauthPending === undefined ? (React.createElement("div", null,
                React.createElement("h2", null, t("Log in or register on the Nexus Mods website")),
                React.createElement("p", null, t("To access this content, please login to the Nexus Mods website.")),
                React.createElement("p", null, t("Click the button below to start the login/registration process.")),
                React.createElement(Button, { tooltip: t("Start login"), onClick: this.login }, t("Login")))) : loginId !== undefined ? ([
                React.createElement(LoginInProgress, { key: "login-in-progress", t: t, loginId: loginId, onCopyToClipboard: () => this.copyToClipboard(oauthPending) }),
                React.createElement(Button, { key: "login-press-authorise", onClick: nop, tooltip: t('Please click "Authorise" on the website'), disabled: true },
                    React.createElement("div", null,
                        React.createElement(Spinner, null),
                        t('Please click "Authorise" on the website'))),
                React.createElement("a", { key: "troubleshoot-button", onClick: this.troubleshoot }, t("Not working? Try manual login.")),
            ]) : (React.createElement("div", null,
                React.createElement("h2", null, t("Log in or register on the Nexus Mods website")),
                React.createElement("p", null, t("Look out for a browser window opening and log in/register if required.")),
                React.createElement("div", { className: "login-please-click" },
                    React.createElement(Spinner, null),
                    React.createElement("h4", null, t('Please click "authorise" on the website'))),
                React.createElement("h3", null, t("Website didn't open?")),
                React.createElement("p", null, t("Copy the following address into your browser window. We support Chrome, Safari, Firefox and Edge.")),
                React.createElement(CopyClipboardInput, { inputValue: oauthPending }),
                React.createElement("p", null,
                    t("Still not working?"),
                    " ",
                    React.createElement("a", { key: "troubleshoot-button", onClick: this.troubleshoot }, t("Log in with token")))))));
    }
    renderTroubleshoot() {
        const { apiKeyInput, context, invalidToken } = this.state;
        const { t, oauthPending } = this.props;
        const keyValid = this.mKeyValidation.test(apiKeyInput);
        return (React.createElement("div", { className: "login-content" },
            React.createElement(Icon, { className: "nexus-header", name: "nexus-header", svgStyle: "#login-dialog path { fill: black }" }),
            React.createElement("h2", null, t("Log in with token")),
            React.createElement("ol", { style: { textAlign: "left" } },
                React.createElement("li", null,
                    React.createElement("p", null, t("Copy the following address into your browser and log in/register if required (skip this step if you already have the token). We support Chrome, Safari, Firefox and Edge.")),
                    React.createElement(CopyClipboardInput, { inputValue: oauthPending })),
                React.createElement("li", null,
                    React.createElement("p", null, t('Click "Authorise" on the website and you will be given a token, copy and paste the token below and click save.')),
                    React.createElement(PlaceholderTextArea, { t: t, mModalRef: this.mModalRef, className: "token-paste-textarea", onChange: this.updateAPIKey }))),
            React.createElement(Button, { tooltip: t("Save"), onClick: this.applyKey }, t("Save")),
            React.createElement("div", { className: "login-invalid-key-group", style: { visibility: invalidToken ? "visible" : "hidden" } },
                React.createElement("p", { className: "login-invalid-key-danger" }, t("Your token was not recognised.")),
                React.createElement("p", { className: "login-invalid-key-details" }, t("Please try again. Copy the token using the button on the website.")))));
    }
    decodeB64(input) {
        return Buffer.from(input, "base64").toString();
    }
    applyKey = async () => {
        try {
            const decoded = JSON.parse(this.decodeB64(this.state.apiKeyInput));
            await this.props.onReceiveCode(decoded.authorization_code, decoded.state);
            this.nextState.invalidToken = false;
            this.props.onHide();
        }
        catch (err) {
            this.nextState.invalidToken = true;
            this.context.api.showErrorNotification("Invalid token", err, {
                allowReport: false,
            });
        }
    };
    onShowContext = (event) => {
        const modalDom = findDOMNode(this.mModalRef.current);
        const rect = modalDom.getBoundingClientRect();
        this.nextState.context = {
            x: event.clientX - rect.x,
            y: event.clientY - rect.y,
        };
    };
    onHideContext = () => {
        this.nextState.context = undefined;
    };
    storeKey(key) {
        this.nextState.apiKeyInput = key.replace(/\s/g, "");
    }
    handlePaste = () => {
        this.storeKey(clipboard.readText());
        this.nextState.context = undefined;
    };
    renderConfirmDialog() {
        return this.context.api.showDialog("question", "Login incomplete", {
            text: "Vortex is not logged in yet, are you sure you wish to abort the login process?",
        }, [
            { label: "Cancel" },
            {
                label: "Abort Login",
                action: () => {
                    this.hide();
                },
            },
        ]);
    }
    openApiAccess = () => {
        opn(API_ACCESS_URL).catch(() => null);
    };
    hide = () => {
        const { onCancelLogin, onHide } = this.props;
        onCancelLogin();
        onHide();
    };
    updateAPIKey = (evt) => {
        this.storeKey(evt.target.value);
    };
    close = () => {
        const { onResetOauthPending } = this.props;
        this.nextState.invalidToken = false;
        // wipe the redux state
        onResetOauthPending();
        this.hide();
    };
    troubleshoot = () => {
        this.nextState.troubleshoot = true;
    };
    copyToClipboard(text) {
        try {
            clipboard.writeText(text);
            // show the clipboard message, turn it off again 3 seconds later
            this.nextState.showElement = true;
            setTimeout(() => (this.nextState.showElement = false), 3000);
        }
        catch (err) {
            // apparently clipboard gets lazy-loaded and that load may fail for some reason
            this.context.api.showErrorNotification("Failed to access clipboard", err, { allowReport: false });
        }
    }
    login = () => {
        const { onHide } = this.props;
        this.nextState.requested = true;
        this.context.api.events.emit("request-nexus-login", (err) => {
            this.nextState.requested = false;
            if (err !== null && !(err instanceof UserCanceled)) {
                this.context.api.showErrorNotification("Failed to get access key", err, { id: "failed-get-nexus-key", allowReport: false });
            }
            onHide();
        });
    };
}
function mapStateToProps(state) {
    return {
        userInfo: state.persistent.nexus.userInfo,
        loginId: state.session.nexus.loginId || undefined,
        loginError: state.session.nexus.loginError || undefined,
        oauthPending: state.session.nexus.oauthPending || undefined,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onSetAPIKey: (APIKey) => dispatch(setUserAPIKey(APIKey)),
        onShowLoginError: (message) => dispatch(showDialog("error", "Error", { message }, [{ label: "Close" }])),
        onResetLoginId: () => dispatch(setLoginId(undefined)),
        onResetOauthPending: () => dispatch(setOauthPending(undefined)),
    };
}
export default translate(["common"])(connect(mapStateToProps, mapDispatchToProps)(LoginDialog));
